import { useState } from "react";
import { FaPlus } from "react-icons/fa";
import { InputNumber, Modal, Spin } from "antd";
import axiosLLInstance from "../../utils/axiosLLInstance.js";
import { InboxOutlined } from "@ant-design/icons";
import { Upload } from "antd";
import * as XLSX from "xlsx";
import { useSelector } from "react-redux";
import ConfirmDialog from "./ConfirmDialog.jsx";
import axiosInstance from "./../../utils/axiosForRevoke";
import { notifyUser } from "../../utils/notifyUser.js";
import Preview from "./Preview.jsx";
import { Action } from "../../utils/constants.js";
const { Dragger } = Upload;

export default function HandleDevices({
  action,
  fleetId,
  setImeiFile,
  setImeiOpt,
}) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const { thing_group } = useSelector((state) => state.fleets.fleet);
  const [previewData, setPreviewData] = useState(null);
  const [duplicates, setDuplicates] = useState(false);
  const [loader, setLoader] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [interval, setInterval] = useState(5);

  const draggerProps = {
    name: "file",
    multiple: false,
    accept: ".xlsx",
    maxCount: 1,
    beforeUpload: async (file) => {
      try {
        setLoading(true);
        setSelectedFile(file);
        const formData = new FormData();
        formData.append("file", file);
        if (action !== Action.ADD) {
          formData.append("fleetId", fleetId);
          formData.append("action", action);
        }
        const { data } = await axiosInstance.post(
          `/provision/check_duplicates`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );
        const { duplicates, message } = data;
        setDuplicates(duplicates.length ? true : false);
        setPreviewData(duplicates);
        if (duplicates.length) {
          notifyUser({
            message: message,
            type: "error",
          });
          return;
        }
        handlePreview(file);
      } catch (error) {
        console.log("Error", error);
      } finally {
        setLoading(false);
      }
      return false;
    },
    onRemove: () => {
      setPreviewData([]);
      setSelectedFile(null);
    },
  };

  const verifyUser = () => {
    axiosLLInstance
      .post(`/email/otp`)
      .then(async () => {
        document.getElementById("my_modal_2").showModal();
      })
      .catch((error) => {
        console.error("Error verifying", error);
      })
      .finally(setShowConfirm(false));
  };

  const handlePreview = (file) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const fileData = e.target.result;

      if (file.name.endsWith(".xlsx")) {
        const workbook = XLSX.read(new Uint8Array(fileData), {
          type: "array",
        });
        const sheetName = workbook.SheetNames[0];
        const sheetData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {
          header: 1,
          raw: false,
        });

        const headers = sheetData[0].map((h) => h.toLowerCase().trim());

        const allowedFields = ["imei", "device_id", "dispatch_date"];

        const columnIndexMap = {};
        headers.forEach((header, index) => {
          columnIndexMap[header] = index;
        });

        const processedData = sheetData
          .slice(1)
          .map((row) => {
            const obj = {};

            allowedFields.forEach((field) => {
              if (columnIndexMap[field] !== undefined) {
                obj[field] = row[columnIndexMap[field]]
                  ? row[columnIndexMap[field]].toString().trim()
                  : null;
              }
            });

            return obj;
          })
          .filter((row) => Object.values(row).some((value) => value));

        setPreviewData(processedData);
      } else {
        notifyUser({
          message: "Unsupported file format",
          type: "error",
        });
      }
    };

    if (file.name.endsWith(".xlsx")) {
      reader.readAsArrayBuffer(file);
    } else {
      reader.readAsText(file);
    }
  };

  const upload = () => {
    if (duplicates.length) {
      return;
    }
    try {
      if (!selectedFile) {
        notifyUser({
          message: "Please select a csv or file",
          type: "error",
        });
        return;
      }
      if (!thing_group) {
        notifyUser({
          message: "Please select Fleet",
          type: "error",
        });
        return;
      }
      setOpen(false);
      setLoader(true);
      const formData = new FormData();
      formData.append("file", selectedFile);
      formData.append("thing_group", thing_group);

      setImeiOpt(true);
      switch (action) {
        case Action.ADD:
          setImeiFile({
            formData,
            url: `/provision/fleets/${fleetId}/add`,
            action,
          });
          break;
        case Action.WHITELIST:
          setImeiFile({
            formData,
            url: `/provision/fleets/${fleetId}/whitelist`,
            action,
          });
          break;
        case Action.BLACKLIST:
          setImeiFile({
            formData,
            url: `/provision/fleets/${fleetId}/blacklist`,
            action,
          });
          break;
        case Action.REVOKE:
          setImeiFile({
            formData,
            url: `/provision/fleets/${fleetId}/revoke`,
            action,
          });
          break;
        case Action.UPDATE_DISPATCH:
          setImeiFile({
            formData,
            url: `/provision/fleets/${fleetId}/dispatch`,
            action,
          });
          break;
        case Action.UPDATE_CONFIG:
          formData.append("interval", interval);
          setImeiFile({
            formData,
            url: `/provision/fleets/${fleetId}/config`,
            action,
          });
          break;
        default:
          return null;
      }

      setShowConfirm(true);
    } catch (error) {
      console.error(`Error ${action}`, error);
    } finally {
      setLoader(false);
    }
  };

  return (
    <>
      <div className="adminBtn">
        <button
          disabled={loader}
          onClick={() => {
            setSelectedFile(null);
            setPreviewData([]);
            setOpen(true);
          }}
          className={`btn ${
            action === Action.REVOKE ? "bg-white text-black border border-gray-300" : "btn-neutral"
          } font-bold py-2 px-4 rounded-[10px] flex items-center justify-between text-[14px]`}
        >
          {action}
          {action === Action.REVOKE ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-trash3"
              viewBox="0 0 16 16"
            >
              <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" />
            </svg>
          ) : (
            <FaPlus className="pl-1 text-[18px]" />
          )}
        </button>
      </div>
      {open && (
        <Modal
          centered
          width={700}
          open={open}
          onOk={() => setOpen(false)}
          onCancel={() => setOpen(false)}
          footer={[]}
          style={{
            height: "90vh",
          }}
        >
          <div className="m-4">
            <Dragger {...draggerProps}>
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">
                Click or drag file to this area, Upload your IMEI {action} File
                for <strong>{thing_group}</strong> fleet
              </p>
              <p className="ant-upload-hint">Select only excel format.</p>
            </Dragger>
            {action === Action.UPDATE_CONFIG && (
              <InputNumber
                min={5}
                max={60}
                value={interval}
                placeholder="Packet Interval"
                size="large"
                className="w-full mt-2"
                addonAfter="min"
                onChange={(val) => {
                  if (val === null) {
                    setInterval(5);
                    return;
                  }
                  setInterval(val);
                }}
              />
            )}
            {!loader && (
              <button
                disabled={duplicates}
                onClick={upload}
                className="btn text-white gap-2 btn-neutral btn-block rounded text-[17px] font-[500] landing-[19px] mt-8"
              >
                Upload
              </button>
            )}
            <div>
              {loading && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    margin: "8px",
                  }}
                >
                  <Spin spinning={loading} />
                </div>
              )}
              <Preview data={previewData} duplicate={duplicates} />
            </div>
          </div>
        </Modal>
      )}
      {showConfirm && (
        <ConfirmDialog
          content={<p>Are you sure?</p>}
          onOk={verifyUser}
          onCancel={() => setShowConfirm(false)}
        />
      )}
    </>
  );
}
